import {GetParametersDecoded} from "../delme_globals";
import globalsObject from "../globalsObject";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {ResourceInvalidationTriggers, ResourceManager} from "@k/global/resourcemanager/resourceManager";
import {SelectedFeature} from "../product";
import {arrayElementByKeyValue} from "@k/global/arrayHelper";
import {createSelectedFeature} from "@k/global/createSelectedFeature";


export function startup(infoFromGetParameters:GetParametersDecoded, isKundenKonfi:boolean, loginOnPageLoad:(username:string, password:string)=>void) {
    if (infoFromGetParameters.login !== "") {
        prepareUserLoginOnLoad(infoFromGetParameters, isKundenKonfi, loginOnPageLoad);
    } else {
        globalsObject.controller.getInitialSession();
        if(infoFromGetParameters.saveId !== null) {
            ResourceManager.createTaskStatic("loadEntwurfFromGetParameters").when("initialSessionarrivedEvent", "done").thenDo(()=>{
                globalsObject.actionController.loadSavedEntwurf(infoFromGetParameters.saveId, false);
            })
        } else {
            loadInitialModel(infoFromGetParameters, isKundenKonfi);
        }
    }
}

function prepareUserLoginOnLoad(infoFromGetParameters:GetParametersDecoded, isKundenKonfi:boolean, loginOnPageLoad:(login:string, password:string)=>void) {
    if (infoFromGetParameters.login !== "") {
        loginOnPageLoad(infoFromGetParameters.login, '');
    } else {
        EventVerteiler.broadcast("showComponentEvent", "login");
    }

    globalsObject.resourceManager.createTask("loadEntwurfFromGetParameter")
        .invalidAfter("loginFailed")
        .when("userLoggedIn", "successful")
        .thenDo(function () {
            if (infoFromGetParameters.saveId !== null) {
                globalsObject.actionController.loadSavedEntwurf(infoFromGetParameters.saveId, false);
            } else {
                loadInitialModel(infoFromGetParameters, isKundenKonfi);
            }
        });
    globalsObject.resourceManager.createTask("loadInitialModelAfterLoginFailed")
        .invalidAfter(ResourceInvalidationTriggers.USERCHANGED)
        .when("userLoggedIn", "failed")
        .thenDo(function () {
                infoFromGetParameters.saveId = null;
                loadInitialModel(infoFromGetParameters, isKundenKonfi);
            }
        );
}


function loadInitialModel(infoFromGetParameters:GetParametersDecoded, isKundenKonfi:boolean) {
    const designString = infoFromGetParameters.productInfo.design || "";
    const selectedFeatures = infoFromGetParameters.productInfo.featureObjects.map(fo => getSelectedFeature(fo, infoFromGetParameters.specificFeatures));
    if (isKundenKonfi) {
        globalsObject.actionController.loadKundenKonfiVorbelegungsSaveIDByDBSchnittAndSelectedFeatures(infoFromGetParameters.productInfo.DVSchnitt, selectedFeatures, designString).then((response)=>{
            if(response.data.saveIDFound) {
                globalsObject.actionController.loadSavedEntwurf(response.data.saveID, false);
                globalsObject.resourceManager.createTask("makeEntwurfDirty")
                    .when("loadedEntwurfInitialized", "done")
                    .thenDo(() => globalsObject.actionController.model.entwurf.setChangedSinceSave(false))
            } else {
                globalsObject.controller.loadInitialProduct(
                    isKundenKonfi,
                    designString,
                    selectedFeatures
                );
            }
        })
    } else {
        globalsObject.controller.loadInitialProduct(
            isKundenKonfi,
            designString,
            selectedFeatures
        );
    }

    if (infoFromGetParameters.fbPostID !== "") {
        globalsObject.controller.loadFacebookPost(infoFromGetParameters.fbPostID);
    }
    if (infoFromGetParameters.productInfo.readyDesign !== "" && infoFromGetParameters.productInfo.readyDesign !== undefined) {
        globalsObject.controller.loadReadyDesign(infoFromGetParameters.productInfo.ordertype, infoFromGetParameters.productInfo.readyDesign.replace(/#.*$/, ""));
    }
}

function getSelectedFeature(featuredObject, specificFeatures) {

    if(typeof(specificFeatures[featuredObject.FeaturedObject]) !== "undefined" && getSpecificFeature(featuredObject, specificFeatures) !== null) {
        const feature = getSpecificFeature(featuredObject, specificFeatures);
        return new SelectedFeature(
            featuredObject.FeaturedObject,
            feature.Feature,
            feature.Name,
            feature.Kuerzel,
            feature.einzublendendeDreiDParts,
            feature.imKonfiBeiDerProduktuebersichtAuswaehlbar,
            feature.imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature,
            featuredObject.zeigeZugehoerigeFeatureBeiFeatureAuswahlAn
        );
    } else {
        const feature = arrayElementByKeyValue(featuredObject.Features, "Feature", featuredObject.StandardFeature);
        return createSelectedFeature(featuredObject, feature)
    }
}

function getSpecificFeature(featuredObject, specificFeatures) {
    return arrayElementByKeyValue(featuredObject.Features, "Feature", specificFeatures[featuredObject.FeaturedObject]);
}
